import { render, staticRenderFns } from "./com-partner2.vue?vue&type=template&id=2711cd5f&scoped=true&"
import script from "./com-partner2.vue?vue&type=script&lang=js&"
export * from "./com-partner2.vue?vue&type=script&lang=js&"
import style0 from "./com-partner2.vue?vue&type=style&index=0&id=2711cd5f&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2711cd5f",
  null
  
)

export default component.exports